import Preview3d from './lib/preview3d';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('preview3d');
const root = createRoot(container as Element);

root.render(<Preview3d />);

export default Preview3d;
